<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right"></div>
    </div>
    <div style="
        font-size: 32px;
        text-align: left;
        color: #e51550;
        border-bottom: 1px solid #ccc;
        padding: 5px;
        font-weight: 400;
        margin-bottom: 25px;
      ">
        {{ $t('settings.ui.companySettingsTitle') }}
    </div>

    <div v-if="loading">
        <i class="fas fa-circle-notch fa-spin"></i> {{ $t('settings.ui.pleaseWait') }}<br />
        {{ $t('settings.ui.loadingCompanySettings') }}<br />
        <div style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"></div>
    </div>

    <div v-if="!loading && !hasAccessRights">
      <strong>{{ $t('settings.ui.noPermission') }}</strong>
      <br />
        {{ $t('settings.ui.contactAdmin') }}
      <br style="clear: both" />
      <div
        style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
      ></div>
    </div>

    <div v-if="!loading && hasAccessRights && otherError">
      <strong>{{ $t('settings.ui.dataQueryError') }}</strong>
      <br/>
      {{ $t('settings.ui.reloadPage') }}<br/>
      <br/>
      {{ $t('settings.ui.contactSupportIfContinues') }}<br/>
      <small class="text-muted">&lt; {{ otherErrorMessage }} &gt;</small>
      <br style="clear: both"/>
      <div
          style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
      ></div>
    </div>

    <div v-if="!loading && hasAccessRights && !otherError && companyData == null">
      {{ $t('settings.ui.storeDataNotLoaded') }}
      <br style="clear: both"/>

      <div
          style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
      ></div>
    </div>

    <div v-if="!loading && hasAccessRights && !otherError && companyData != null">
      <!-- Einstellungen -->
      <div class="xColumn3">
        <div class="header">
            {{ $t('settings.ui.settingsHeader') }}
        </div>

        <div class="entryBox">
            <div class="entryHeader">{{ $t('settings.ui.internalId') }}</div>
            <div class="entryData">
                {{ internalId }}
            </div>
        </div>

        <div class="entryBox">
            <div class="entryHeader">{{ $t('settings.ui.companyName') }}</div>
            <div class="entryData">
                {{ companyName }}
            </div>
        </div>

        <div class="entryBox">
            <div class="entryHeader">{{ $t('settings.ui.additionalText') }}</div>
            <div class="entryData">
                {{ companyDescription }}
            </div>
        </div>
        <div class="entryBox">
          <div class="entryHeader">{{ $t('settings.ui.country') }}</div>
          <div class="entryData">
            {{ companyCountry.valueGER }}
          </div>
        </div>

        <div class="entryBox">
            <div class="entryHeader">
                {{ $t('settings.ui.companyNumber') }}
                <small><em class="text-secondary">{{ $t('settings.ui.freeText') }}</em></small>
            </div>
            <div v-if="saves || !editieren" class="entryData">
                {{ companyNumber }}
            </div>
            <div v-if="!saves && editieren" class="entryData">
                <input v-model="inputCompanyNumber" />
            </div>
        </div>
        <br/>



        <div class="entryBox">
            <div class="entryHeader">
                {{ $t('settings.ui.lvSoftware') }}
            </div>

            <div v-if="saves || !editieren" class="entryData">
                {{ externalSoftwaresMap[companyData.softwareId]
                ? externalSoftwaresMap[companyData.softwareId].name
                : $t('settings.ui.unknownSoftware')
                }}
            </div>
          <div v-if="!saves && editieren" class="entryData">
            <select class="modern-select" v-model="inputSoftwareId" style="width: 100%">
              <option
                v-for="(entry) in Object.values(externalSoftwaresMap).filter(item => item.active || item.id == companyData.softwareId)"
                :value="entry.id"
                :key="'exs' + entry.id"
              >
                {{ entry.name }}
              </option>
            </select>
          </div>
        </div>


        <div
          v-if="!companyData.individualStoreIds && companyData.softwareId == 0"
          class="entryBox"
        >
          <div class="entryHeader">LV - BMD ID</div>
          <div v-if="saves || !editieren" class="entryData">
            {{ bmdId }}
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <input v-model="inputBmdId" />
          </div>
        </div>
        <div
          v-if="!companyData.individualStoreIds && companyData.softwareId == 1"
          class="entryBox"
        >
          <div class="entryHeader">LV - DPW ID</div>
          <div v-if="saves || !editieren" class="entryData">
            {{ dpwId }}
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <input v-model="inputDpwId" />
          </div>
        </div>

        <!-- TODO -- TAKE THIS KEY-VALUES FROM THE ENUM /api/enum/socialinsuranceregistrationmode -->
        <div class="entryBox">
            <div class="entryHeader">
                {{ $t('settings.ui.employeeSvSetting') }}
            </div>
            <div v-if="saves || !editieren" class="entryData">
                <span v-if="socialInsuranceRegistrationMode == 0">
                  {{ $t('settings.ui.svMode0') }}
                </span>

                <span v-if="socialInsuranceRegistrationMode == 1">
                    {{ $t('settings.ui.svMode1') }}
                </span>

                <span v-if="socialInsuranceRegistrationMode == 2">
                    {{ $t('settings.ui.svMode2') }}
                </span>
            </div>

            <div v-if="!saves && editieren" class="entryData">
            <select class="modern-select" v-model="inputSocialInsuranceRegistrationMode" style="width: 100%">
              <option
                v-for="(entry, key) in enumSocialInsuranceRegistrationModes"
                :value="key"
                :key="'sim' + key">
                {{ entry }}
              </option>
            </select>
          </div>
        </div>

        <div class="entryBox">
            <div class="entryHeader">
                {{ $t('settings.ui.enableEldaService') }}
            </div>
          <div v-if="saves || !editieren" class="entryData">
            <i
              class="fas fa-check-circle checkbox"
              v-bind:class="{ false: !useEldaService }"
            ></i>
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <i
              class="fas fa-check-circle checkbox"
              v-bind:class="{ false: !inputUseEldaService }"
              v-on:click="inputUseEldaService = !inputUseEldaService"
            ></i>
          </div>
        </div>

        <div class="entryBox">
            <div class="entryHeader">
                {{ $t('settings.ui.mdEmployeeDataChangeMode') }}
            </div>
          <div v-if="saves || !editieren" class="entryData">
            <span v-if="true">{{ enumEmployeeChangedFromMDModes[employeeChangedFromMDMode] }}</span>
            <!--<span v-if="socialInsuranceRegistrationMode == 1">Mitarbeiteränderungen benötigen eine Bestätigung</span>-->
          </div>
          <div v-if="!saves && editieren" class="entryData">
            <select class="modern-select" v-model="inputEmployeeChangedFromMDMode" style="width: 100%">
              <option
                v-for="(entry, key) in enumEmployeeChangedFromMDModes"
                :value="key"
                :key="'ecm' + key"
              >
                {{ entry }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Standorte -->
      <div class="xColumn3">
          <div class="header">
              {{ $t('settings.ui.locationsHeader') }}
              <small class="text-secondary"><em>{{ $t('settings.ui.costCentersHint') }}</em></small>
          </div>

          <div v-for="store in storesDataFiltered" :key="'store' + store.id">

              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.locationName') }}
                  </div>
                  <div class="entryData">{{ store.name }}</div>
              </div>

              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.additionalText') }}
                  </div>
                  <div class="entryData">{{ store.description }}</div>
              </div>

              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.locationNumber') }}
                      <small class="text-secondary"><em>{{ $t('settings.ui.freeText') }}</em></small>
                  </div>
                  <div v-if="saves || !editieren" class="entryData">
                      {{ store.storeNumber }}
                  </div>
                  <div v-if="!saves && editieren" class="entryData">
                      <input v-model="store.inputStoreNumber" />
                  </div>
              </div>

              <div v-if="companyData.softwareId == 0" class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.locationBmdId') }}
                  </div>
                  <div v-if="saves || !editieren" class="entryData">
                      {{ store.bmdId }}
                  </div>
                  <div v-if="!saves && editieren" class="entryData">
                      <input v-model="store.inputBmdId" />
                  </div>
              </div>

              <div v-if="companyData.softwareId == 1" class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.locationDpwId') }}
                  </div>
                  <div v-if="saves || !editieren" class="entryData">
                      {{ store.dpwId }}
                  </div>
                  <div v-if="!saves && editieren" class="entryData">
                      <input v-model="store.inputDpwId" />
                  </div>
              </div>

              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.locationCostCenterId') }}
                  </div>
                  <div v-if="saves || !editieren" class="entryData">
                      {{ store.costCenter }}
                  </div>
                  <div v-if="!saves && editieren" class="entryData">
                      <input v-model="store.inputCostCenter" />
                  </div>
              </div>

              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.address') }}
                  </div>
                  <div class="entryData">
                      {{ store.address }}
                  </div>
              </div>

              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.postalCity') }}
                  </div>
                  <div class="entryData">
                      {{ store.postalCode }} {{ store.city }}
                  </div>
              </div>

              <div v-if="[2,3,4,5,6].includes(companyData.softwareId)" class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.webcockpitExportEnabled') }}
                  </div>

                  <div class="entryData" v-if="saves || !editieren">
                      <strong>{{ store.isWebcockpitExportEnabled ? $t('settings.ui.yes') : $t('settings.ui.no') }}</strong>
                  </div>

                  <div class="entryData" v-if="!saves && editieren">
                      <label>
                          <input type="radio" v-model="store.isWebcockpitExportEnabled" :value="1" />
                          On
                      </label>
                      &nbsp;&nbsp;&nbsp;
                      <label>
                          <input type="radio" v-model="store.isWebcockpitExportEnabled" :value="0" />
                          Off
                      </label>
                  </div>
              </div>

              <hr style="clear: both; margin-top: 8px; margin-bottom: 0px;" />

          </div>
      </div>

      <!-- Elda Dienstgeber -->
      <div v-if="useEldaService" class="xColumn3">
          <div class="header">
              {{ $t('settings.ui.eldaEmployerSettings') }}
          </div>
          <div class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.ui.employerName') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
                  {{ eldaEmployerName }}
              </div>
              <div v-if="!saves && editieren" class="entryData">
                  <input v-model="inputEldaEmployerName" style="width: 100%"/>
              </div>
          </div>
          <div class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.ui.employerPhone') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
                  {{ eldaEmployerPhoneNumber }}
              </div>
              <div v-if="!saves && editieren" class="entryData">
                  <input v-model="inputEldaEmployerPhoneNumber" style="width: 100%"/>
              </div>
          </div>
          <div class="entryBox">
              <div class="entryHeader">
                  {{ $t('settings.ui.employerEmail') }}
              </div>
              <div v-if="saves || !editieren" class="entryData">
                  {{ eldaEmployerEmail }}
              </div>
              <div v-if="!saves && editieren" class="entryData">
                  <input v-model="inputEldaEmployerEmail" style="width: 100%"/>
              </div>
          </div>
          <div class="entryBox">
              <div style="
                    display: inline-block;
                    width: 95%;
                    float: left;
                    color: #555;
                    font-weight: 700;">
                  {{ $t('settings.ui.insurerAndAccountNumber') }}
              </div>

              <div
                  v-if="!saves && editieren"
                  v-tooltip="$t('settings.ui.addInsurerTooltip')"
                  class="button small fas fa-plus"
                  @click="addInsurer()"
                  style="display: inline-block; width: 5%; float: right; font-weight: 700"></div>
          </div>

          <div v-if="saves || !editieren">
              <div
                  v-for="eldaInsurer in eldaEmployerInsurer"
                  :key="'show' + eldaInsurer.id"
                  class="entryBox">
                  <div style="
                        display: inline-block;
                        width: 50%;
                        float: left;
                        color: #555;
                        font-weight: 700;">
                      {{ getInsurerLabelByKey(eldaInsurer.insurer) }}
                  </div>
                  <div class="entryData">
                      {{ eldaInsurer.contribution_accountnumber }}
                  </div>
              </div>
          </div>
          <div v-if="!saves && editieren">
              <div
                  v-for="(eldaInsurer, index) in inputEldaEmployerInsurer"
                  :key="'edit' + eldaInsurer.id"
                  class="entryBox">
                  <div style="
                        display: inline-block;
                        width: 50%;
                        float: left;
                        color: #555;
                        font-weight: 700;">
                      <select
                          class="modern-select"
                          v-model="eldaInsurer.insurer"
                          style="width: 98%">
                          <option
                              v-for="item in $helpers.getEldaInsurerArray()"
                              :value="item.value"
                              :key="'insurer' + item.value">
                              {{ item.label }}
                          </option>
                      </select>
                  </div>

                  <div style="
                        display: inline-block;
                        width: 45%;
                        float: left;
                        color: var(--contrast-5);
                        font-weight: 200;">
                      <input
                          v-model="eldaInsurer.contribution_accountnumber"
                          :key="'can' + index"
                          style="width: 95%"
                      />
                  </div>

                  <div
                      v-tooltip="$t('settings.ui.deleteInsurerTooltip')"
                      class="button small fas fa-trash"
                      @click="deleteInsurer(eldaInsurer.id)"
                      style="display: inline-block; width: 5%; float: right; font-weight: 700"
                  ></div>
              </div>
          </div>
        <br />
      </div>

      <!-- Elda Hersteller -->
      <div v-if="useEldaService" class="xColumn3">
          <div v-if="saves || !editieren" class="header">
              {{ $t('settings.ui.eldaManufacturerSettings') }}
          </div>
          <div v-if="!saves && editieren" class="header" style="width: 93%">
              {{ $t('settings.ui.eldaManufacturerSettings') }}
          </div>
          <div
              v-if="!saves && editieren"
              v-tooltip="$t('settings.ui.addManufacturerTooltip')"
              class="header fas fa-plus"
              @click="addCreator()"
              style="width: 7%; float: right; padding-top: 14px"></div>

          <div v-if="saves || !editieren">
              <div v-for="creator in eldaCreator" :key="'creator' + creator.id">
                  <div class="entryBox">
                      <div class="entryHeader" style="color: #e51550">
                          {{ creator.name }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.eldaSerialNumber') }}</div>
                      <div class="entryData">
                          {{ creator.elda_serial_number }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.eldaPassword') }}</div>
                      <div class="entryData">
                          &#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.periodicClearingCheck') }}</div>
                      <div class="entryData">
                          <i
                              class="fas fa-check-circle checkbox"
                              :class="{ false: !creator.periodic_clearing_check }"
                          ></i>
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.defaultMessageType') }}</div>
                      <div class="entryData">
                          {{ getProjektLabelByKey(creator.defaultProjekt) }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.manufacturerName') }}</div>
                      <div class="entryData">
                          {{ creator.name }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.manufacturerCountry') }}</div>
                      <div class="entryData">
                          {{ getCountryLabelByKey(creator.country) }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.manufacturerPostal') }}</div>
                      <div class="entryData">
                          {{ creator.postal }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.manufacturerCity') }}</div>
                      <div class="entryData">
                          {{ creator.city }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.manufacturerStreet') }}</div>
                      <div class="entryData">
                          {{ creator.street }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.manufacturerPhone') }}</div>
                      <div class="entryData">
                          {{ creator.phone }}
                      </div>
                  </div>

                  <div class="entryBox">
                      <div class="entryHeader">{{ $t('settings.ui.manufacturerEmail') }}</div>
                      <div class="entryData">
                          {{ creator.email }}
                      </div>
                  </div>

                  <hr style="clear: both" />
              </div>
          </div>

        <div v-if="!saves && editieren">
          <div v-for="(creator, index) in inputEldaCreator" v-bind:key="'creator' + creator.id">
              <div class="entryBox">
                  <div v-if="creator.name !== ''" class="entryHeader" style="color: #e51550">
                      {{ creator.name }}
                  </div>
                  <div v-else class="entryHeader" style="color: #e51550">
                      {{ $t('settings.ui.newManufacturer') }}
                  </div>

                  <div
                      v-tooltip="$t('settings.ui.deleteManufacturerTooltip')"
                      class="button small fas fa-trash"
                      @click="deleteCreator(creator.id)"
                      style="display: inline-block; width: 5%; float: right; font-weight: 700"
                  ></div>
              </div>

              <div class="entryBox">
                  <div class="entryHeader">{{ $t('settings.ui.eldaSerialNumber') }}</div>
                  <div class="entryData">
                      <input
                          v-model="creator.elda_serial_number"
                          :key="'serialnumber' + index"
                          style="width: 100%"
                      />
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">{{ $t('settings.ui.eldaPasswordSha') }}</div>
                  <div class="entryData">
                      <i
                          class="fas fa-check-circle checkbox"
                          :key="'pccsha' + index"
                          :class="{ false: !creator.enter_pwd_as_sha512 }"
                          @click="creator.enter_pwd_as_sha512 = !creator.enter_pwd_as_sha512"
                      ></i>
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.eldaPassword') }}
                      <i
                          class="fa fa-circle-info"
                          v-tooltip="$t('settings.ui.eldaPasswordInfo')"
                      ></i>
                  </div>
                  <div class="entryData">
                      <input
                          v-model="creator.elda_password"
                          :key="'password' + index"
                          style="width: 100%"
                      />
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.periodicClearingCheck') }}
                  </div>
                  <div class="entryData">
                      <i
                          class="fas fa-check-circle checkbox"
                          :key="'pcc' + index"
                          :class="{ false: !creator.periodic_clearing_check }"
                          @click="creator.periodic_clearing_check = !creator.periodic_clearing_check"
                      ></i>
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.defaultMessageType') }}
                  </div>
                  <div class="entryData">
                      <select class="modern-select" v-model="creator.defaultProjekt" style="width: 98%">
                          <option
                              v-for="item in $helpers.getEldaProjektArray()"
                              :value="item.value"
                              :key="'epa' + item.value"
                          >
                              {{ item.label }}
                          </option>
                      </select>
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.manufacturerName') }}
                  </div>
                  <div class="entryData">
                      <input
                          v-model="creator.name"
                          :key="'name' + index"
                          style="width: 100%"
                      />
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.manufacturerCountry') }}
                  </div>
                  <div class="entryData">
                      <select
                          class="modern-select"
                          v-model="creator.country"
                          :key="'country' + index"
                          style="width: 100%"
                      >
                          <option
                              v-for="(item, index) in enumCountry"
                              :value="item.kfz"
                              :key="'kfz' + index + item.kfz"
                          >
                              {{ item.valueGER }}
                          </option>
                      </select>
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.manufacturerPostal') }}
                  </div>
                  <div class="entryData">
                      <input
                          v-model="creator.postal"
                          :key="'postal' + index"
                          style="width: 100%"
                      />
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.manufacturerCity') }}
                  </div>
                  <div class="entryData">
                      <input v-model="creator.city" :key="'city' + index" style="width: 100%" />
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.manufacturerStreet') }}
                  </div>
                  <div class="entryData">
                      <input v-model="creator.street" :key="'street' + index" style="width: 100%" />
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.manufacturerPhone') }}
                  </div>
                  <div class="entryData">
                      <input v-model="creator.phone" :key="'phone' + index" style="width: 100%" />
                  </div>
              </div>
              <div class="entryBox">
                  <div class="entryHeader">
                      {{ $t('settings.ui.manufacturerEmail') }}
                  </div>
                  <div class="entryData">
                      <input v-model="creator.email" :key="'email' + index" style="width: 100%" />
                  </div>
              </div>

            <hr style="clear: both" />
          </div>
        </div>
      </div>

      <br style="clear: both" />

      <div
        style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 5px"></div>

      <!--
      <div v-if="companyData.softwareId == 0">
        <strong>BMD-ID</strong> <input v-model="bmdId"/> <button v-if="!saves" type="button" v-on:click="save('bmdId')">Speichern</button> <span v-if="saves">wird gespeichert</span><br/>
      </div>

      <div v-if="companyData.softwareId == 1">
        <strong>DPW-ID</strong> <input v-model="dpwId"/> <button v-if="!saves" type="button" v-on:click="save('dpwId')">Speichern</button> <span v-if="saves">wird gespeichert</span><br/>
      </div>
      -->
    </div>

    <b-modal
      size="lg"
      ref="modal-eldanumber-exists"
      @close="closeEldaNumberExistsModal()"
      centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">{{ $t('settings.ui.warning') }}</div>
            </div>
        </template>

        <b-container fluid>
            <div class="full">
                <h5>{{ $t('settings.ui.eldaSerialExists') }}</h5>
                <h5>{{ $t('settings.ui.eldaLinkToStoreQuestion') }}</h5>

                <br />

                <div style="padding: 1px" class="col-lg-12">
                    <button
                        style="width: 49.5%; margin-right: 1%"
                        type="button"
                        class="btn btn-sm btn-ml"
                        @click="linkTempCreatorToStore();closeEldaNumberExistsModal();">
                        {{ $t('settings.ui.yes') }}
                    </button>

                    <button
                        style="width: 49.5%"
                        type="button"
                        class="btn btn-sm btn-secondary"
                        @click="closeEldaNumberExistsModal()">
                        {{ $t('settings.ui.no') }}
                    </button>
                </div>
            </div>
        </b-container>

        <template slot="modal-footer">
            <div class="button right" @click="closeEldaNumberExistsModal()">
                <div class="label">{{ $t('global.ui.close') }}</div>
            </div>
        </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "companysettings",
  data() {
    return {
      loading: true,
      longLoading: false,

      editieren: false,

      companyData: null,
      storesData: null,

      internalId: "",
      companyName: "",
      companyDescription: "",
      companyCountry: 0,
      companyCountryId: 0,
      bmdId: "",
      dpwId: "",
      companyNumber: "",
      socialInsuranceRegistrationMode: 0,
      useEldaService: false,
      employeeChangedFromMDMode: 0,

      inputBmdId: "",
      inputDpwId: "",
      inputCompanyNumber: "",
      inputSoftwareId: 0,
      inputSocialInsuranceRegistrationMode: 0,
      inputUseEldaService: false,
      inputEmployeeChangedFromMDMode: 0,

      enumSocialInsuranceRegistrationModes: {},
      enumEmployeeChangedFromMDModes: {},
      enumCountry: {},

      newEmailForNotification: "",
      emailsForNewEmployeeNotifications: [],

      eldaCreatorList: [],
      eldaCreatorTempSerialnumber: "",

      eldaEmployerName: "",
      eldaEmployerPhoneNumber: "",
      eldaEmployerEmail: "",
      eldaEmployerInsurer: [],
      eldaCreator: [],

      inputEldaEmployerName: "",
      inputEldaEmployerPhoneNumber: "",
      inputEldaEmployerEmail: "",
      inputEldaEmployerInsurer: [],
      inputEldaCreator: [],

      saves: false,
      hasAccessRights: true,
      otherError: false,
      otherErrorMessage: "",
    };
  },
  created: function () {
    //console.log("CREATED");
  },
  mounted: function () {
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {
        this.enumSocialInsuranceRegistrationModes[0] = this.$t('settings.ui.svMode0');
        this.enumSocialInsuranceRegistrationModes[1] = this.$t('settings.ui.svMode1');
        this.enumSocialInsuranceRegistrationModes[2] = this.$t('settings.ui.svMode2');

        this.enumEmployeeChangedFromMDModes[0] = this.$t('settings.ui.employeeChangeImmediate');
        this.enumEmployeeChangedFromMDModes[1] = this.$t('settings.ui.employeeChangeCoreData');
      //this.enumEmployeeChangedFromMDModes[2] = "Sozialversicherungs Anmeldung und Anmeldedokument Bestätigung erforderlich";

      this.refresh();
    }
  },
  computed: {
    ...mapGetters([
      "companyId",
      "isSuperUser",
      "externalServicesMap",
      "companySettings",
      "selectedStores",
      "externalSoftwaresMap",
    ]),
    dateDisplay: function () {
      return this.$helpers.getMomentTZ().format("YYYY-MM-DD");
    },
    headerButtons() {
      let view = this;

        let state = {
            buttons: [
                {
                    type: "block",
                    icon: "fa-edit",
                    show: !view.saves && !view.editieren,
                    click: () => {
                        view.editieren = !view.editieren;
                    },
                    tooltip: view.$t('settings.ui.edit'),
                    title: view.$t('settings.ui.edit'),
                },
                {
                    type: "block red",
                    icon: "fa-ban",
                    show: !view.saves && view.editieren,
                    click: () => {
                        view.editieren = !view.editieren;
                        view.resetEldaInputs();
                    },
                    tooltip: view.$t('settings.ui.cancel'),
                },
                {
                    type: "block green",
                    icon: "fa-save",
                    show: !view.saves && view.editieren,
                    click: () => {
                        view.save();
                    },
                    tooltip: view.$t('settings.ui.saveChanges'),
                },
                {
                    show: view.saves,
                    type: "block",
                    icon: "fa-spinner fa-spin",
                    click: () => {},
                    tooltip: view.$t('settings.ui.saving'),
                },
            ],
        };
      return state;
    },
    timeZoneList() {
      let result = [];
      /*
            this.timeZones.forEach(i => {
                let item = {label: i, value: i};
                result.push(item);
            })
            */
      return result;
    },
    storesDataFiltered() {
      let filtered = [];
      console.log(this.storesData);
      console.log(this.selectedStores);
      this.storesData.forEach((s) => {
        /*if (
          this.selectedStores.filter((elem) => {
            return s.id == elem.id;
          }).length > 0
        )*/
        filtered.push(s);
      });
      return filtered;
    },
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh(true);
    },
    selectedStores: function (val, oldVal) {
      console.log("Selected stores changed in CompanySettings.vue");
      console.log(oldVal);
      console.log(val);
    },
    eldaCreator: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.eldaCreator.sort((a, b) => {
            if (a.id < b.id) return -1;
            else if (a.id > b.id) return 1;
            else return 0;
          });
        }
      },
    },
    inputEldaCreator: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.inputEldaCreator.sort((a, b) => {
            if (a.id < b.id) return -1;
            else if (a.id > b.id) return 1;
            else return 0;
          });
        }
      },
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
      view.loading = true;
      view.initEldaFields();
      view.loadListForNewEmployeeNotification();
      view.loadEldaEmployerSettings();
      view.loadEldaCreatorSettings();
      view.loadEldaCreatorList();
      view.loadCountryEnum();
      view.$helpers.GetExternalSoftwaresMap();
      view.loadCompanyAndStoreData(force);
    },
    loadCompanyAndStoreData(force) {
      let view = this;
      return view.$helpers
        .GetCompanySettings(force)
        .then((response) => {
          // console.log("Company Settings:", response);
          view.updateCompanySettings(response);
          return view.$helpers.GetStoresSettings(force);
        })
        .then((response) => {
          view.storesData = response.data;
          for (let i = 0; i < view.storesData.length; i++) {
            view.storesData[i].inputBmdId = view.storesData[i].bmdId;
            view.storesData[i].inputDpwId = view.storesData[i].dpwId;
            view.storesData[i].inputStoreNumber = view.storesData[i].storeNumber;
            view.storesData[i].inputCostCenter = view.storesData[i].costCenter;
          }
          setTimeout(function () {
            view.loading = false;
          }, 200);
        })
        .catch((error) => {
          console.log("REFRESH ERROR: " + error);
            view.$helpers.error(
                view.$t('settings.ui.errorTitle'),
                view.$t('settings.ui.errorLoadingData')
            );

            if (error && error.response && error.response.status == 403) {
            view.hasAccessRights = false;
          }
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            view.otherErrorMessage = error.response.data.message;
          }
          view.otherError = true;
          //view.$helpers.error('Fehler', 'Fehler beim Laden der Daten');
          setTimeout(function () {
            view.loading = false;
          }, 200);
        });
    },
    resetEldaInputs() {
      let view = this;
      view.inputEldaEmployerName = view.eldaEmployerName;
      view.inputEldaEmployerPhoneNumber = view.eldaEmployerPhoneNumber;
      view.inputEldaEmployerEmail = view.eldaEmployerEmail;
      view.inputEldaEmployerInsurer = JSON.parse(
        JSON.stringify(view.eldaEmployerInsurer)
      );
      view.inputEldaCreator = JSON.parse(JSON.stringify(view.eldaCreator));
    },
    initEldaFields() {
      let view = this;
      view.eldaEmployerName = "";
      view.eldaEmployerPhoneNumber = "";
      view.eldaEmployerEmail = "";
      view.eldaEmployerInsurer = [];
      view.eldaCreator = [];
    },
    getInsurerLabelByKey: function (key) {
      let label = "";
      this.$helpers.getEldaInsurerArray().forEach(function (item, index) {
        if (item.value === key) {
          label = item.label;
        }
      });
      return label;
    },
    getProjektLabelByKey: function (key) {
      let label = "";
      this.$helpers.getEldaProjektArray().forEach(function (item, index) {
        if (item.value === key) {
          label = item.label;
        }
      });
      return label;
    },
    getCountryLabelByKey: function (key) {
      let label = "";
      Object.values(this.enumCountry).forEach((item) => {
        if (item.kfz === key) {
          label = item.valueGER;
        }
      });
      return label;
    },
    sha512(str, enter_pwd_as_sha512) {
      if (enter_pwd_as_sha512) {
        return Promise.resolve(str);
      }
      if (str !== undefined && str !== null && str !== "") {
        return crypto.subtle
          .digest("SHA-512", new TextEncoder().encode(str))
          .then((buf) => {
            return Array.prototype.map
              .call(new Uint8Array(buf), (x) => ("00" + x.toString(16)).slice(-2))
              .join("");
          });
      } else {
        return Promise.resolve("");
      }
    },

    loadEldaEmployerSettings: function () {
      let view = this;
      let url = "/api/sec/elda/settings/employer";
      const params = {
        companyId: this.$store.state.companyId,
      };
      this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
      })
        .then((response) => {
          let data = response.data;

          console.log(data);

          if (data !== undefined) {
            view.eldaEmployerName = data.name;
            view.eldaEmployerPhoneNumber = data.phone_number;
            view.eldaEmployerEmail = data.email;
            view.eldaEmployerInsurer = JSON.parse(JSON.stringify(data.insurer));

            view.inputEldaEmployerName = data.name;
            view.inputEldaEmployerPhoneNumber = data.phone_number;
            view.inputEldaEmployerEmail = data.email;
            view.inputEldaEmployerInsurer = JSON.parse(JSON.stringify(data.insurer));
          } else {
            view.eldaEmployerName = "";
            view.eldaEmployerPhoneNumber = "";
            view.eldaEmployerEmail = "";
            view.eldaEmployerInsurer = [];

            view.inputEldaEmployerName = "";
            view.inputEldaEmployerPhoneNumber = "";
            view.inputEldaEmployerEmail = "";
            view.inputEldaEmployerInsurer = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadEldaCreatorSettings: function () {
      let view = this;
      let url = "/api/sec/elda/settings/creator";
      const params = {
        companyId: this.$store.state.companyId,
      };
      this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
      })
        .then((response) => {
          let data = response.data;

          console.log(data);
          data.forEach((item) => {
            item.enter_pwd_as_sha512 = false;
          });

          if (data !== undefined) {
            view.eldaCreator = JSON.parse(JSON.stringify(data));
            view.inputEldaCreator = JSON.parse(JSON.stringify(data));
          } else {
            view.eldaCreator = [];
            view.inputEldaCreator = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadEldaCreatorList: function () {
      let view = this;
      let url = "/api/sec/elda/settings/creator/list";
      const params = {
        companyId: this.$store.state.companyId,
      };
      this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
      })
        .then((response) => {
          let data = response.data;

          console.log(data);

          if (data !== undefined) {
            view.eldaCreatorList = JSON.parse(JSON.stringify(data));
          } else {
            view.eldaCreatorList = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadCountryEnum: function () {
      let view = this;
      let url = "/api/enum/country";

      this.axios({
        method: "get",
        headers: {},
        url: url,
      })
        .then((response) => {
          view.enumCountry = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    addInsurer() {
      let view = this;

      let newItem = { insurer: "", contribution_accountnumber: "" };
      // add random negative id to distinguish between old and new entries.
      // new entries will be deleted without backend call, while old entries need to be deleted in the backend as well.
      newItem.id = Math.floor(Math.random() * 9999) - 10000;
      view.inputEldaEmployerInsurer.push(newItem);
    },
    saveInsurer(item) {
      let view = this;
      let url = "/api/sec/elda/settings/insurer";
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/elda/settings/insurer"
      );

      if (item.insurer === "" || item.contribution_accountnumber === "") {
        view.inputEldaEmployerInsurer = view.inputEldaEmployerInsurer.filter(
          (insurer) => {
            return insurer.id !== item.id;
          }
        );
          view.$helpers.info(
              view.$t('settings.ui.infoTitle'),
              view.$t('settings.ui.incompleteInsurerRemoved')
          );
        return;
      }

      this.axios({
        method: "post",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        data: item,
      })
        .then((response) => {
          view.eldaEmployerInsurer = view.eldaEmployerInsurer.filter((insurer) => {
            return insurer.id !== item.id;
          });
          view.eldaEmployerInsurer.push({ ...response.data });
          view.inputEldaEmployerInsurer = view.inputEldaEmployerInsurer.filter(
            (insurer) => {
              return insurer.id !== item.id;
            }
          );
          view.inputEldaEmployerInsurer.push({ ...response.data });
            view.$helpers.success(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.insurerAdded')
            );
        })
        .catch(function (error) {
          console.log(error);
            view.$helpers.error(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.errorAddingInsurer')
            );
        });
    },
    deleteInsurer(id) {
      let view = this;

      if (id < 0) {
        view.inputEldaEmployerInsurer = view.inputEldaEmployerInsurer.filter(
          (insurer) => {
            return insurer.id !== id;
          }
        );
        return;
      }

      let url = "/api/sec/elda/settings/insurer";
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/elda/settings/insurer"
      );
      url = this.$helpers.appendParam("id", id, url, "/api/sec/elda/settings/insurer");

      this.axios({
        method: "delete",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
      })
        .then((response) => {
          view.eldaEmployerInsurer = view.eldaEmployerInsurer.filter((insurer) => {
            return insurer.id !== id;
          });
          view.inputEldaEmployerInsurer = view.inputEldaEmployerInsurer.filter(
            (insurer) => {
              return insurer.id !== id;
            }
          );
            view.$helpers.success(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.insurerDeleted')
            );
        })
        .catch(function (error) {
          console.log(error);
            view.$helpers.error(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.errorDeletingInsurer')
            );
        });
    },

    addCreator() {
      let view = this;

      let newItem = {
        enter_pwd_as_sha512: false,
        elda_serial_number: "",
        elda_password_sha512: "",
        periodic_clearing_check: false,
        defaultProjekt: "",
        name: "",
        country: "",
        postal: "",
        city: "",
        street: "",
        phone: "",
        email: "",
      };
      // add random negative id to distinguish between old and new entries.
      // new entries will be deleted without backend call, while old entries need to be deleted in the backend as well.
      newItem.id = Math.floor(Math.random() * 9999) - 10000;
      view.inputEldaCreator.push(newItem);
    },
    saveNewCreator(item) {
      let view = this;
      let url = "/api/sec/elda/settings/creator";
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/elda/settings/creator"
      );

      let exists = false;
      view.eldaCreatorList.forEach((creator) => {
        if (creator.elda_serial_number === item.elda_serial_number) {
          view.eldaCreatorTempId = creator.id;
          view.$refs["modal-eldanumber-exists"].show();
          view.resetEldaInputs();
          exists = true;
        }
      });
      if (exists) {
        return;
      }

      if (
        item.elda_serial_number === "" ||
        item.elda_password === "" ||
        item.name === "" ||
        item.country === "" ||
        item.postal === "" ||
        item.city === "" ||
        item.street === ""
      ) {
        view.inputEldaCreator = view.inputEldaCreator.filter((creator) => {
          return creator.id !== item.id;
        });
          view.$helpers.info(
              view.$t('settings.ui.infoTitle'),
              view.$t('settings.ui.incompleteManufacturerRemoved')
          );
        return;
      }

      view.sha512(item.elda_password, item.enter_pwd_as_sha512).then((result) => {
        item.elda_password_sha512 = result;
        item.elda_password = "";

        this.axios({
          method: "post",
          headers: {
            AUTHORIZATION: "Bearer " + this.$store.state.jwt,
          },
          url: url,
          data: item,
        })
          .then((response) => {
            view.eldaCreator = view.eldaCreator.filter((creator) => {
              return creator.id !== item.id;
            });
            response.data.data.enter_pwd_as_sha512 = false;
            view.eldaCreator.push(response.data.data);
            view.inputEldaCreator = view.inputEldaCreator.filter((creator) => {
              return creator.id !== item.id;
            });
            view.inputEldaCreator.push(response.data.data);
              view.$helpers.success(
                  view.$t('settings.ui.infoTitle'),
                  view.$t('settings.ui.manufacturerAdded')
              );
          })
          .catch(function (error) {
            console.log(error);
              view.$helpers.error(
                  view.$t('settings.ui.infoTitle'),
                  view.$t('settings.ui.errorAddingManufacturer')
              );
          });
      });
    },
    updateCreator(item) {
      let view = this;
      let url = "/api/sec/elda/settings/creator";
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/elda/settings/creator"
      );

      view
        .sha512(item.elda_password, item.enter_pwd_as_sha512)
        .then((result) => {
          item.elda_password_sha512 = result;
          item.elda_password = "";

          let original = view.eldaCreator.find((org) => item.id === org.id);
          original.elda_password = "";
          if (JSON.stringify(item) !== JSON.stringify(original)) {
            this.axios({
              method: "put",
              headers: {
                AUTHORIZATION: "Bearer " + this.$store.state.jwt,
              },
              url: url,
              data: item,
            })
              .then((response) => {
                view.eldaCreator = view.eldaCreator.filter((creator) => {
                  return creator.id !== item.id;
                });
                response.data.enter_pwd_as_sha512 = false;
                view.eldaCreator.push({ ...response.data });
                view.inputEldaCreator = view.inputEldaCreator.filter((creator) => {
                  return creator.id !== item.id;
                });
                view.inputEldaCreator.push({ ...response.data });
                  view.$helpers.success(
                      view.$t('settings.ui.infoTitle'),
                      view.$t('settings.ui.manufacturerUpdated')
                  );
              })
              .catch(function (error) {
                console.log(error);
                  view.$helpers.error(
                      view.$t('settings.ui.infoTitle'),
                      view.$t('settings.ui.errorUpdatingManufacturer')
                  );
              });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deleteCreator(id) {
      let view = this;

      if (id < 0) {
        view.inputEldaCreator = view.inputEldaCreator.filter((creator) => {
          return creator.id !== id;
        });
        return;
      }

      let url = "/api/sec/elda/settings/creator";
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/elda/settings/creator"
      );
      url = this.$helpers.appendParam("id", id, url, "/api/sec/elda/settings/creator");

      this.axios({
        method: "delete",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
      })
        .then((response) => {
          view.eldaCreator = view.eldaCreator.filter((creator) => {
            return creator.id !== id;
          });
          view.inputEldaCreator = view.inputEldaCreator.filter((creator) => {
            return creator.id !== id;
          });
            view.$helpers.success(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.manufacturerDeleted')
            );
        })
        .catch(function (error) {
          console.log(error);
            view.$helpers.error(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.errorDeletingManufacturer')
            );
        });
    },
    linkTempCreatorToStore(id) {
      let view = this;
      let url = "/api/sec/elda/settings/creator/link";

      let payload = {
        companyId: this.$store.state.companyId,
        creatorId: view.eldaCreatorTempId,
      };

      this.axios({
        method: "post",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
          this.refresh();
        })
        .catch(function (error) {
          console.log(error);
            view.$helpers.error(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.errorAddingManufacturer')
            );
        });
    },

    loadListForNewEmployeeNotification: function () {
      let view = this;
      let url = "/api/sec/notification/email/newemployeeList";
      const params = {
        companyId: this.$store.state.companyId,
      };
      this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
      })
        .then((response) => {
          view.emailsForNewEmployeeNotifications = response.data.data;
        })
        .catch(function (error) {});
    },
    saveEmailForNewEmployeeNotification: function () {
      let view = this;
      let url = "/api/sec/notification/email/newemployeeList";
      const params = {
        companyId: this.$store.state.companyId,
      };
      let payload = {
        email: view.newEmailForNotification,
      };
      this.axios({
        method: "post",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
        data: payload,
      })
        .then((response) => {
          view.newEmailForNotification = "";
            view.$helpers.success(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.emailAdded')
            );
            view.loadListForNewEmployeeNotification();
        })
        .catch(function (error) {
            view.$helpers.error(
                view.$t('settings.ui.infoTitle'),
                view.$t('settings.ui.errorAddingEmail')
            );
        });
    },
    deleteEmailForNewEmployeeNotification: function (id) {
      let view = this;
      let url = "/api/sec/notification/email/newemployeeList";
      const params = {
        companyId: this.$store.state.companyId,
      };
      let payload = {
        id: id,
      };
      this.axios({
        method: "delete",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        params,
        data: payload,
      })
          .then((response) => {
              view.$helpers.success(
                  view.$t('settings.ui.infoTitle'),
                  view.$t('settings.ui.emailDeleted')
              );
              view.loadListForNewEmployeeNotification();
          })
          .catch(function (error) {
              view.$helpers.error(
                  view.$t('settings.ui.infoTitle'),
                  view.$t('settings.ui.errorDeletingEmail')
              );
          });
    },

    updateCompanySettings: function (response) {
      let view = this;
      view.hasAccessRights = true;

      if (response.data.length == 1) {
        view.companyData = response.data[0];
        view.inputSoftwareId = view.companyData.softwareId;

        view.internalId = view.companyData.id;
        view.companyName = view.companyData.name;
        view.companyDescription = view.companyData.description;
        view.companyCountry = view.companyData.billing_address ? view.companyData.billing_address.country : null;
        view.companyCountryId = view.companyData.billing_address ? view.companyData.billing_address.countryId : 0;
        view.bmdId = view.companyData.bmdId;
        view.dpwId = view.companyData.dpwId;
        view.companyNumber = view.companyData.companyNumber;
        view.socialInsuranceRegistrationMode = view.companyData.socialInsuranceRegistrationMode;
        view.useEldaService = view.companyData.useEldaService;
        view.employeeChangedFromMDMode = view.companyData.employeeChangedFromMDMode;

        view.inputBmdId = view.bmdId;
        view.inputDpwId = view.dpwId;
        view.inputCompanyNumber = view.companyNumber;
        view.inputSocialInsuranceRegistrationMode = view.socialInsuranceRegistrationMode;
        view.inputUseEldaService = view.useEldaService;
        view.inputEmployeeChangedFromMDMode = view.employeeChangedFromMDMode;
      }
    },

    save: function (key) {
      let view = this;
      view.saves = true;

      let softwareIdChanged = view.inputSoftwareId !== view.companyData.softwareId;
      let useEldaServiceChanged = view.inputUseEldaService !== view.companyData.useEldaService;

      let payload = {
        companyId: this.$store.state.companyId,
        bmdId: this.inputBmdId,
        dpwId: this.inputDpwId,
        companyNumber: this.inputCompanyNumber,
        softwareId: this.inputSoftwareId,
        socialInsuranceRegistrationMode: this.inputSocialInsuranceRegistrationMode,
        useEldaService: this.inputUseEldaService,
        employeeChangedFromMDMode: this.inputEmployeeChangedFromMDMode,
      };
      payload["stores"] = [];
      for (let i = 0; i < view.storesData.length; i++) {
        payload["stores"].push({
          storeId: view.storesData[i].id,
          bmdId: view.storesData[i].inputBmdId,
          dpwId: view.storesData[i].inputDpwId,
          costCenter: view.storesData[i].inputCostCenter,
          storeNumber: view.storesData[i].inputStoreNumber,
          isWebcockpitExportEnabled: view.storesData[i].isWebcockpitExportEnabled,
        });
      }

      let url = "/api/company";

      this.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
          view.bmdId = view.inputBmdId;
          view.dpwId = view.inputDpwId;
          view.companyNumber = view.inputCompanyNumber;
          view.companyData.softwareId = view.inputSoftwareId;
          view.socialInsuranceRegistrationMode = view.inputSocialInsuranceRegistrationMode;
          view.useEldaService = view.inputUseEldaService;
          view.employeeChangedFromMDMode = view.inputEmployeeChangedFromMDMode;

          for (let i = 0; i < view.storesData.length; i++) {
            view.storesData[i].bmdId = view.storesData[i].inputBmdId;
            view.storesData[i].dpwId = view.storesData[i].inputDpwId;
            view.storesData[i].costCenter = view.storesData[i].inputCostCenter;
            view.storesData[i].storeNumber = view.storesData[i].inputStoreNumber;
          }
        })
        .then((response) => {
          view.saveEldaCreatorSettings();
          if (view.inputEldaEmployerName != null && view.inputEldaEmployerName !== "") {
            view.saveEldaEmployerSettings();
          }
        }).then((response) => {
          view.editieren = false;
          view.saves = false;

          if (softwareIdChanged) {
            view.$store.commit("setExternalSoftware", { software: view.inputSoftwareId });
            view.$parent.setExternalSoftware(parseInt(view.inputSoftwareId));
          }

          if (useEldaServiceChanged) {
            view.$parent.setUseEldaService(view.inputUseEldaService);
            view.$parent.setCountryId(view.companyCountryId);
          }

          view.loadCompanyAndStoreData(true)
              .then(() => {
                  view.$helpers.success(
                      view.$t('settings.ui.saveSuccessTitle'),
                      view.$t('settings.ui.saveSuccessMessage')
                  );
              })
              .catch(function (error) {
                  console.log(error);
                  view.saves = false;
                  view.$helpers.error(
                      view.$t('settings.ui.saveErrorTitle'),
                      view.$t('settings.ui.saveErrorMessage')
                  );
              });

        })
        .catch(function (error) {
          console.log(error);
          view.saves = false;
            view.$helpers.error(
                view.$t('settings.ui.saveErrorTitle'),
                view.$t('settings.ui.saveErrorMessage')
            );
          /*
          view.deletingPref = false;
          view.$helpers.error('Löschen fehlgeschlagen', 'Fehler beim Löschen der Abwesenheit');
        */
        });
    },
    saveEldaEmployerSettings: function () {
      let view = this;
      let payload = {
        companyId: this.$store.state.companyId,
        name: view.inputEldaEmployerName,
        phone_number: view.inputEldaEmployerPhoneNumber,
        email: view.inputEldaEmployerEmail,
        insurer: view.inputEldaEmployerInsurer,
      };

      // update elda settings
      this.axios({
        method: "post",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: "/api/sec/elda/settings/employer",
        data: payload,
      }).then((response) => {
        let newInsurer = view.inputEldaEmployerInsurer.filter((insurer) => {
          return insurer.id < 0;
        });
        newInsurer.forEach((insurer) => {
          view.saveInsurer(insurer);
        });

        view.eldaEmployerName = view.inputEldaEmployerName;
        view.eldaEmployerPhoneNumber = view.inputEldaEmployerPhoneNumber;
        view.eldaEmployerEmail = view.inputEldaEmployerEmail;
        view.eldaEmployerInsurer = JSON.parse(
          JSON.stringify(view.inputEldaEmployerInsurer)
        );

        view.editieren = false;
      });
    },
    saveEldaCreatorSettings: function () {
      let view = this;

      let existingCreators = view.inputEldaCreator.filter((creator) => {
        return creator.id > 0;
      });
      existingCreators.forEach((creator) => {
        view.updateCreator(creator);
      });

      let newCreators = view.inputEldaCreator.filter((creator) => {
        return creator.id < 0;
      });
      newCreators.forEach((creator) => {
        view.saveNewCreator(creator);
      });
    },

    closeEldaNumberExistsModal() {
      this.$refs["modal-eldanumber-exists"].hide();
    },
  },
};
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.xColumn3 {
  width: 31%;
  text-align: left;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
  overflow-y: auto;
}

.xColumn3 > .header {
  display: inline-block;
  width: 100%;
  color: #e51550;
  font-size: 15px;
  font-weight: 700;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 7px;
}

.entryBox {
  font-size: 13px;
  text-align: left;
  padding: 3px 7px;
  display: flex;
  align-items: center;
}

.entryBox > .entryHeader {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-4);
  font-weight: 700;
}

.entryBox > .entryHeaderLight{
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox > .entryData {
  display: inline-block;
  width: 50%;
  float: right;
  color: var(--contrast-5);
  font-weight: 200;
}

.btn-ml {
  color: #fff;
  background-color: var(--ml);
  border-color: var(--ml);
}

.btn-ml:hover {
  color: #fff;
  background-color: #cc1347;
  border-color: #cc1347;
}
</style>
